/// <reference path="../Scripts/Public/Security.js" />
/// <reference path="../Scripts/Public/jquery-1.6.2.min.js" />
/// <reference path="../Scripts/Public/AJAX.js" />
var allowed = "veritracks.com";
if (document.domain.indexOf(allowed) !== -1) {
    document.domain = allowed;
}
var gUserDetails = null,
    gPasswordResetUserId = '',
    gPasswordResetSecurityQuestionId = '',
    gPasswordResetSecurityQuestion = '',
    gPasswordUsePasswordPolicy = false,
    mTreeDisplayController = null,
    mFailureCount = 0,
    mStateManager,
    mOrganizations,
    mParentOri,
    mEnabledSuperOri = 0,
    mCurrentSuperOri,
    mSingleSchema = false,
    lIsSiteUp = false,
    mChildCount = 0,
    mRegionalCutOff = 0,
    graph = [];

var credentialsTemp = { UserName: "", Password: "" };
var tokenList = [];
var legacyBrowsers = ["MSIE8","MSIE9"];

var gRerouteEnabled = (gServerList.veritracks.length > 1 ? true : false);
var gRerouteSchemas = [];

/// authentication
function organization_OnChange(aEvent) {
    "use strict";
    var lSelected = $('.SuperUserOrganization:checked'),
        lValue = { 'value': aEvent.target.defaultValue, 'checked': aEvent.target.checked },
        lItem,
        lKey,
        lParentFlag;

        lParentFlag = checkParentOriFlag(lValue.value);
        if (lSelected.length - mChildCount > 5) {
            var lItem = '#uOrganizationSelect' + aEvent.target.defaultValue.toString();
            $(lItem).attr('checked', false);
        }
        else {
            if (mEnabledSuperOri) {
                if (lParentFlag) {
                    if (lValue.checked) {
                        mCurrentSuperOri = lValue.value;
                    }
                    else {
                        mCurrentSuperOri = null;
                    }
                    ParentOriSelected(lValue);
                }
            }
        }
}

function checkParentOriFlag(aValue) {
    "use strict";
    var lKey,
        lOrganization,
        lParentFlag;
        //lValue = aValue.value;

    for (lKey in mOrganizations) {
        if (mOrganizations.hasOwnProperty(lKey)) {
            lOrganization = mOrganizations[lKey];
            if (lOrganization.Id == aValue) {
                lParentFlag = lOrganization.ParentOriFlag;
            }
        }
    }
    return lParentFlag;
}

function ParentOriSelected(aParentOri) {
    "use strict";
    var lParentOriId = aParentOri.value,
        lParentOriChecked = aParentOri.checked,
        lKey,
        lParent,
        lCheck,
        lCount = 0;

    if (!isNullOrUndefined(mParentOri)) {
        for (lKey in mParentOri) {
            if (mParentOri.hasOwnProperty(lKey)) {
                lParent = mParentOri[lKey];
                if (lParent.Id == lParentOriId) {
                    lCheck = '#uOrganizationSelect' + lParent.ChildId.toString();
                    $(lCheck).attr('checked', lParentOriChecked);
                    $(lCheck).attr('disabled', 'disabled');
                    lCount++;
                }
            }
        }
    }
    if ($('#uOrganizationSelect' + lParentOriId.toString()).prop('checked') == true) {
        mChildCount = $('.SuperUserOrganization:checked').filter(':disabled').length - 1;
    }
    else {
        mChildCount = 0;
    }
    disableCheckbox(lParentOriId, lParentOriChecked);

}

function disableCheckbox(lParentOriId, lParentOriChecked) {
    var lSelected = $('.SuperUserOrganization:checked'),
        lKey,
        lOrganization,
        lCheck;

    if (lParentOriChecked) {
     //   $('.SuperUserOrganization:checked').attr('disabled', 'disabled');
        for (lKey in mOrganizations) {
            if (mOrganizations.hasOwnProperty(lKey)) {
                lOrganization = mOrganizations[lKey];
                if (lOrganization.ParentOriFlag == 1) {
                    lCheck = '#uOrganizationSelect' + lOrganization.Id.toString();
                    $(lCheck).attr('disabled', 'disabled');
                }
            }
        }
        lCheck = '#uOrganizationSelect' + lParentOriId.toString();
        $(lCheck).removeAttr("disabled");
    }
    else {
        for (lKey in mOrganizations) {
            if (mOrganizations.hasOwnProperty(lKey)) {
                lOrganization = mOrganizations[lKey];
                lCheck = '#uOrganizationSelect' + lOrganization.Id.toString();
                $(lCheck).removeAttr('disabled');
            }
        }
    }
}

function showHideOriChildren(parent) {
    "use strict";
    
    var $children = $("#" + parent).children("ul");
   
    if ($("#link" + parent).hasClass("plusSignImage")) {
        $("#link" + parent).removeClass("plusSignImage");
        $("#link" + parent).addClass("subtractSignImage");
    } else if ($("#link" + parent).hasClass("subtractSignImage")) {
        $("#link" + parent).removeClass("subtractSignImage");
        $("#link" + parent).addClass("plusSignImage");
    } else {
        //this link is not a parent
    }

    $children.each(function (index) {
        if ($(this).hasClass("OriUlCommon")) {
            $(this).removeClass("OriUlCommon");
            $(this).addClass("OriUlCommonHide");
        } else {
            $(this).removeClass("OriUlCommonHide");
            $(this).addClass("OriUlCommon");
        }
    });

    
}

function onOriReadSuccess(aParams, aData) {
    "use strict";
    var oriKeyList = [],
        loginOriList = [],             
        lItem,          
        lKey;
    mTreeDisplayController = new VeritracksTreeDisplayController('uOrganizationHolder', { 'Overflow': false });
    mOrganizations = aData;

   
    mTreeDisplayController.setDataSource(mOrganizations);

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            loginOriList.push(lItem);
            oriKeyList.push(lItem.Id);           
            
        }
    }//end of for

    if (mEnabledSuperOri == 0) {
        mTreeDisplayController.buildFlatTree(aData);
        $("#uOrganizationPanelLoadingBar").remove();
        return;
    }
    else {
        mTreeDisplayController.buildGraphTree(loginOriList, oriKeyList);
    }

    
             
        $('.SuperUserOrganization').change(organization_OnChange).change();
        selectCurrentOrisTree();
    if ($("#uOrganizationsText").val() != '') {
            uSearchOrganizations();
        }
            
    $("#uOrganizationPanelLoadingBar").remove();
}

function selectCurrentOrisTree() {
    "use strict";   

    $("a[class~= 'openOriParent']").each(function (index) {
       this.onclick();        
    });


}

function populateOrganizationList() {
    "use strict"

    $("#uOrganizationsText").focusout(uFocusOutInit);   

    var lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression();
    lSort.addAscendingColumn('OriPath');   
    
    function failure(aParams, a, b, c) {

    }
    
    lBuilder.AddNewExpressionConditional('Id', gUserDetails.AvailableOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple('Veritracks.Core.Organization, Veritracks.Core, Culture=neutral, PublicKeyToken=null', lBuilder.RootExpression, 0, onOriReadSuccess, failure, {}, lSort, 0, false);    
    
}

function populateSchemaList() {
    "use strict";
    var lItems = [],
        lKey,
        lItem;

    if (gUserDetails.AvailableSchemas.length == 1) {
        var lSchema = gUserDetails.AvailableSchemas[0];
        setSchema(lSchema.Name);
    } else {
        $('#uLoginPanel').hide();
        $('#u2FAPanel').hide();
        $('#uSchemaPanel').show();
        $('#uOrganizationPanel').hide();
        for (lKey in gUserDetails.AvailableSchemas) {
            if (gUserDetails.AvailableSchemas.hasOwnProperty(lKey)) {
                lItem = gUserDetails.AvailableSchemas[lKey];
                lItems[lKey] = '<option value="' + lItem.Name + '">' + lItem.Description + '</option>';
            }
        }
        $('#uSchemaSelect').html(lItems.join(''));
    }
}



function getClientSettingSuperOri() {
    "use strict";
    function ClientSettingRead_Success(aParams, aData) {
        "use strict";
    
        for (var lKey in aData) {
            if(aData.hasOwnProperty(lKey)){
                if(aData[lKey].Id == 58)
                    mEnabledSuperOri = parseInt(aData[lKey].Value);
                else
                    mRegionalCutOff = parseInt(aData[lKey].Value);
            }
        }
    
        if (mEnabledSuperOri) {
            getParentOriList();
        } else {
            populateOrganizationList();
        }
    }
    var lBuilder = new SumoPredicateBuilder();
    // get client setting property
    lBuilder.AddNewExpressionConditional('Id', 58, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    lBuilder.AddNewExpressionConditional('Id', 135, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
    ReadMultiple('Veritracks.Core.ClientSetting, Veritracks.Core, Culture=neutral, PublicKeyToken=null', lBuilder.RootExpression, 0, ClientSettingRead_Success, null, {}, null, 0, false);
}

function getParentOriList() {
    "use strict";
    // get parent Ori
    function OriParentRead_Success(aParams, aData) {
        "use strict";
        mParentOri = aData;
        populateOrganizationList();
    }
    ReadMultiple('Veritracks.Core.OriParent, Veritracks.Core, Culture=neutral, PublicKeyToken=null', null, 0, OriParentRead_Success, null, {}, null, 0, false);
}


function getUserDetails() {
    "use strict";
    var lToken = veritracks.security.controller.tryGetSecurityToken();
    function getUserDetails_OnComplete(aParams, aData) {
        "use strict";
        gUserDetails = aData;
         if (gUserDetails.HasCurrentSchema === false) {
            populateSchemaList();    
         }
         else if (gUserDetails.AvailableOrganizationIds.length > 5 && gUserDetails.OrganizationIds.length === 0) {
             $('#uLoginPanel').hide();
             $('#u2FAPanel').hide();
             $('#uSchemaPanel').hide();
             $('#uOrganizationPanel').show();
             getClientSettingSuperOri();
         }
         else {
             sessionStorage.veritracksservice = gServiceUrlList;
             $('form:first').submit();
             window.location.href = '../';
         }
    }
    function getUserDetails_OnFailure(aParams, a, b, c) {
        "use strict";
        var f = b;
    }
    callAjax('GetUserDetails', { 'aSecurityToken': lToken }, getUserDetails_OnComplete, getUserDetails_OnFailure, null);
}

function getUserDetailsFromToken() {
    "use strict";
    var lToken = veritracks.security.controller.tryGetSecurityToken();
    function getUserDetails_OnComplete(aParams, aData) {
        "use strict";
        gUserDetails = aData;
         if (gUserDetails.HasCurrentSchema === false) {
            populateSchemaList();    
         }
         else if (gUserDetails.AvailableOrganizationIds.length > 5 && gUserDetails.OrganizationIds.length === 0) {
             $('#uLoginPanel').hide();
             $('#u2FAPanel').hide();
             $('#uSchemaPanel').hide();
             $('#uOrganizationPanel').show();
             getClientSettingSuperOri();
         }
         else {
             sessionStorage.veritracksservice = gServiceUrlList;
             $('form:first').submit();
             window.location.href = '../';
         }
    }
    function getUserDetails_OnFailure(aParams, a, b, c) {
        "use strict";
        var f = b;
    }
    callAjax('GetUserDetailsFromToken', { 'aSecurityToken': lToken }, getUserDetails_OnComplete, getUserDetails_OnFailure, null);
}

function authenticationSuccess(aOutParams, aToken) {
    "use strict";
    if (aToken == "LOCKED") {
        $('#uAuthenticationLocked').fadeIn("slow");
        return false;
    }

    updateVeritracksServerToken(aToken, gServerList.veritracks[0]);

    Is2FARequired(aOutParams);
}

function authenticationFailure(aParams, XMLHttpRequest, textStatus, errorThrown) {
    "use strict";
    $('#uAuthenticationError').fadeIn("slow");
}

function beginAuthentication(aUserName, aPassword) {
    "use strict";
    $('#uAuthenticationLocked').hide();
    $('#uAuthenticationError').hide();
    $('#uAuthenticationAccessError').hide();
    updateVeritracksServerToken('invalidtoken', gServerList.veritracks[0]);
    credentialsTemp.UserName = aUserName;
   credentialsTemp.Password = aPassword;

    //CallAuthApi('POST', '/authentication/', {}, {'HeaderName':'Authorization', 'HeaderValue':'Basic ' + btoa(aUserName + ":" + aPassword)}, authenticationSuccess, authenticationFailure);

   // multiServerAuthentication(aUserName, aPassword);
    callAjax('Authenticate',
        { 'aCredentials': credentialsTemp },
        authenticationSuccess,
        authenticationFailure,
        null);

}

function setSchema_OnComplete(aParams, aData) {
    "use strict";
    getUserDetails();
}

function updateVeritracksServerToken(aToken, server) {

    veritracks.security.controller.clearCookie('VeritracksAuthenticationToken');

    veritracks.security.controller.setCookie('VeritracksAuthenticationToken', aToken);
    
    gServiceUrlList = server;

}

function setSchema_OnFailure(aParams, a, b, c) {
    "use strict";
    var lHtml = [],
    lButtonBar = GenerateButtonCommandBar();

    var browser = get_browser() + get_browser_version();

    lHtml.push('<div id="uUserSchemaError">');
    if ($.inArray(browser, legacyBrowsers) !== -1) {
		gServiceIndex = 0;
        lHtml.push('The security settings of your current browser (IE8 or IE9) are not supported with this version of VeriTracks,');
		lHtml.push(' please contact the Solution Center at 1-866-703-7867.');
		lHtml.push(' To login click <a href="https://ds02.veritracks.com">here</a>.');
    }
    lHtml.push('</div>');

    GenerateButton('Close', 'Cancel', ClosePopup).appendTo(lButtonBar);
    DisplayPopup('Error', lHtml.join(''), lButtonBar, false);
}

function setSchema(aSchemaName) {
    "use strict";
    function ChangeResourceServerOnAuthorizationFail(aSchemaName, aData) {
        if (aData) {
            var lToken = veritracks.security.controller.tryGetSecurityToken();
            callAjax('SetUserClientSchema', { 'aSecurityToken': lToken, 'aSchemaName': aSchemaName }, setSchema_OnComplete, setSchema_OnFailure, lToken);
            return;
        }
    
        // authenticate on new server
        callAjax('Authenticate',
        {
            'aCredentials': credentialsTemp
        },
        function (aParams, aToken) {
            updateVeritracksServerToken(aToken, gServiceUrlList);
            callAjax('SetUserClientSchema', { 'aSecurityToken': aToken, 'aSchemaName': aSchemaName }, setSchema_OnComplete, setSchema_OnFailure, aToken);
        },
        authenticationFailure,
        null);
    }
    var lToken = veritracks.security.controller.tryGetSecurityToken();

    if (reRouteSchema(aSchemaName) && gRerouteEnabled) {
	    displayCaliforniaPopup();
	    return;
	}

    //gServiceUrlList = ["www.veritracks.com", "v11.veritracks.com", "veritracks.com", "a1v11.lab.veritracks.com"].indexOf(window.location.host) !== -1 ? getSchemaServer(aSchemaName) : gServiceUrlList; // fix to stop rerouting when not on production www.veritracks.com
    //always reroute because its apple-pie now
    //console.log(getSchemaServer(aSchemaName));
    gServiceUrlList = getSchemaServer(aSchemaName);
    // do some logic to determine server has not changed.
    callAjax('IsAuthorized', { 'aSecurityToken': lToken }, ChangeResourceServerOnAuthorizationFail, null, aSchemaName);
}



function getSchemaServer(aSchemaName) {   
    var lSchema = gUserDetails.AvailableSchemas.find(function (schema) {
        return schema.Name == aSchemaName;
    });
    if (window.location.hostname.indexOf('localhost') >= 0) {
        return gServerList.veritracks[0];
    }

    return lSchema.ServiceURL + VERITRACKS_SERVICE_ENDPOINT;
}

function reRouteSchema(aSchemaName) {
    "use strict";
    var reroute = false;
    var lBuilder;
    var schemaArray;
    var schemaInfo;

    if (gRerouteSchemas.indexOf(aSchemaName) !== -1) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Name', aSchemaName, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        schemaArray = query(gUserDetails.AvailableSchemas, lBuilder.RootExpression);
        for (var lKey in schemaArray) {
            if (schemaArray.hasOwnProperty(lKey)) {
                if (schemaArray[lKey]) {
                    schemaInfo = schemaArray[lKey];
                }
            }
        }

        if (window.location.href.indexOf(schemaInfo.ServiceURL) >= 0) {
            reroute = false;
        } else {
            reroute = true;
        }
    }

    return reroute;
}

function displayCaliforniaPopup(){
	"use strict";
	var lHtml = [],
    lButtonBar = GenerateButtonCommandBar();

    lHtml.push('<div id="uUserSchemaCalifornia">');
	lHtml.push('A dedicated infrastructure has been setup for CDCR.');
	lHtml.push(' To utilize this new site ensure that when logging into VeriTracks 11 you are going to https://cdcr.veritracks.com')
	lHtml.push(' – click <a href="https://cdcr.veritracks.com">here</a> to be automatically redirected.');
    lHtml.push('</div>');

    GenerateButton('Close', 'Cancel', ClosePopup).appendTo(lButtonBar);
    DisplayPopup('CDCR User', lHtml.join(''), lButtonBar, false);
}

function setOrganizations() {
    "use strict";
    var lSelected = $('.SuperUserOrganization:checked');
    if (lSelected.length > 0) {
        if (lSelected.length > 5) {
            OrganizationWarning(lSelected.length)
        }
        else {
            setOrganizationFinal();
        }
    }
}
function setOrganizationFinal() {
    var lSelected = $('.SuperUserOrganization:checked'),
        lToken = veritracks.security.controller.tryGetSecurityToken(),
        lIds = [],
        lItem,
        lKey,
        isRegional = false;
    if (gUserDetails.Role !== 2) {
        for (lKey = 0; lKey < lSelected.length; ++lKey) {
            lItem = lSelected[lKey];
            lIds.push($(lItem).val());
        }
    }
    else {
        if (gUserDetails.ExtendedOrganizationIds.length > 0) {
            lIds = gUserDetails.ExtendedOrganizationIds;
        }
    }

    for (lKey in mOrganizations) {
        lItem = mOrganizations[lKey];
        if (mOrganizations.hasOwnProperty(lKey)) {
            if (lIds.indexOf(lItem.Id.toString()) != -1 && lItem.TreeLevel <= mRegionalCutOff) {
                isRegional = true;
                break;
            }            
        }
    }

    callAjax('SetUserOrganizations', { 'aSecurityToken': lToken, 'aOrganizationIds': lIds, 'aRegionalOri': isRegional }, setSchema_OnComplete, setSchema_OnFailure, null);
}

function OrganizationWarning(lOriCount) {
    "use strict";
    var lHtml = [],
        lButtonBar = GenerateButtonCommandBar();

    lHtml.push('<div id="uUserHighOrganizationCount">');
    lHtml.push('You are logging into a Parent Organization. Veritracks is going to attempt to load all ');
    lHtml.push('[');
    lHtml.push(lOriCount);
    lHtml.push(']');
    lHtml.push(' Child Organizations under this Parent Organization. This may be time consuming and could result in degraded system performance.');
    lHtml.push('</div>');

    GenerateButton('Continue', 'Continue', setOrganizationFinal).appendTo(lButtonBar);
    GenerateButton('Cancel', 'Cancel', ClosePopup).appendTo(lButtonBar);
    DisplayPopup('Warning', lHtml.join(''), lButtonBar, false);
}

function uForgotPassword_OnClick() {
    "use strict";
    $('#uLoginPanel').hide();
    $('.ForgotPasswordStep1').show();
    $('.ForgotPasswordHeader').show();
}

function updateUserPasswordFlag_OnSuccess(aParams, aData) {
    "use strict";
    $('#uLoginPanel').show();
    $('.ForgotPasswordStep1').hide();
    $('.ForgotPasswordStep2').hide();
    $('.ForgotPasswordStep3').hide();
    $('.ForgotPasswordStep4').hide();
    $('.ForgotPasswordScore').hide();
    $('.ForgotPasswordHeader').hide();
    $('.ForgotPasswordPasswordChanged').show();
    $('.ForgotPasswordError').hide();
    $('.PasswordAlreadyUsed').hide();
}

function resetPasswordUpdateUser_OnSuccess(aParams, aData) {
    "use strict";

    if (!isNullOrUndefined(aData)) {
        updateUserPasswordFlag_OnSuccess();
    }
    
}

function resetPassword_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
        
    if (aData === 1) {        
    
        lBuilder.AddNewExpressionConditional('Id', aParams, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        try {
            ReadMultiple('Veritracks.Core.User, Veritracks.Core, Culture=neutral, PublicKeyToken=null', lBuilder.RootExpression, 0, resetPasswordUpdateUser_OnSuccess, resetPassword_OnFailure, {}, null, 0, false);   
        }
        catch (Exception) {            
            updateUserPasswordFlag_OnSuccess();
        }

    } else if (aData === -1) {
        $('.ForgotPasswordStep2').show();
        $('.PasswordSecurityAnswerError').show();
    }
    else if (aData === 0) {
        $('.ForgotPasswordStep2').show();
        $('.ForgotPasswordStep3').show();
        $('.ForgotPasswordError').show();
    } else if (aData == -2) {
        $('.ForgotPasswordStep2').show();
        $('.PasswordAlreadyUsed').show();
    } else {
        veritracks.system.raiseFailure('A fatal error occurred. Please contact support for assistance.');
    }
}

function resetPassword_OnFailure(aParams, a, b, c) {
    "use strict";

}

function analyzePasswordStrength() {
    "use strict";
    var lPassword = $('#uForgotPasswordNewPassword').val();
    //  console.log(zxcvbn(lPassword, ["stopllc", "veritracks"]).score);
    if (gPasswordUsePasswordPolicy) {
        showScoreCard((getPasswordStrength(lPassword)));
    }
}

function getPasswordStrength(aPassword) {
    return customPasswordStrength(aPassword);
}

function zxcvbnPasswordStrength(aPassword) {
    var lScore = zxcvbn(aPassword, ["stopllc", "veritracks"]).score;

    if (aPassword == "") {
        lScore = -1;
    }
    return lScore;
}

function customPasswordStrength(aPassword) {
    "use strict";
    var lScore = 0;
    if (aPassword.length >= 8) {
        var regex = /^(?=.*[a-z]).+$/;
        var regex2 = /^(?=.*[A-Z]).+$/;

        if (regex.test(aPassword) && regex2.test(aPassword)) {
            lScore++;
        }
        var regex = /^(?=.*[0-9]).+$/;

        if (regex.test(aPassword)) {
            lScore++;
        }
        var regex = /^(?=.*[!@#\$%\^\&*\)\(+=._-]).+$/;

        if (regex.test(aPassword)) {
            lScore++;
        }

        if (aPassword.length >= 10 && lScore == 3) {
            lScore++;
        }
        /* if (lScore == 4) {
            console.log(zxcvbnPasswordStrength(aPassword));
        } */
    }
    if (aPassword == "") {
        lScore = -1;
    }

    return lScore;
}

function resetPassword(aUserId, aSecurityQuestionId, aSecurityAnswer, aPassword) {
    "use strict";
    var lStrength = getPasswordStrength(aPassword);

    if (aPassword.length > 20) {
        $('.PasswordLong').show();
        return;
    }
    if (gPasswordUsePasswordPolicy && lStrength <= 2) {
        $('.PasswordWeak').show();
        return;
    }
    callAjax('ForgotPassword',
        { 'aUserId': aUserId, 'aSecurityQuestionId': aSecurityQuestionId, 'aSecurityAnswer': aSecurityAnswer, 'aPassword': aPassword },
        resetPassword_OnSuccess,
        resetPassword_OnFailure,
        aUserId);
}


function resetPassword_OnClick() {
    var lSecurityAnswer = $('#uForgotPasswordSecurityAnswer').val(),
        lResetPassword = $('#uForgotPasswordNewPassword').val();
    $('.ForgotPasswordStep2').hide();
    $('.PasswordAlreadyUsed').hide();
    $('.PasswordSecurityAnswerError').hide();
    $('.ForgotPasswordError').hide();
    $('.ForgotPasswordStep3').show();
        resetPassword(gPasswordResetUserId, gPasswordResetSecurityQuestionId, lSecurityAnswer, lResetPassword);

}


function hideScoreCard() {
    "use strict";
    for (var i = 0; i <= 4; i++) {
        $('.ScoreCard' + i).removeClass('Reached');
        $('.scoreText' + i).hide();
    }
}

function showScoreCard(score) {
    "use strict";
    hideScoreCard();
    $('.ScoreCard' + score).addClass('Reached');
    $('.scoreText' + score).show();
    if (score == 0) {
        $('.ScoreCard1').addClass('Reached');
        $('.scoreText1').show();
        return;
    }
    while (score > 0) {
        score = score - 1;
        $('.ScoreCard' + score).addClass('Reached');
    }
}

function getPasswordResetDetails_OnComplete(aParams, aData) {
    "use strict";
    if (aData.UserId === -1) {
        $('#uForgotPasswordUserError').show();
    } else {
        gPasswordResetUserId = aData.UserId;
        gPasswordResetSecurityQuestion = aData.SecurityQuestion;
        gPasswordResetSecurityQuestionId = aData.SecurityQuestionId;
        gPasswordUsePasswordPolicy = (aData.PasswordPolicy == 1);
        //if (aData.SecurityQuestion === '-1') {
        //    $('#uForgotPasswordQuestionError').show();
        //} else {
            if (aData.Status === 1) {
                $('.ForgotPasswordHeader').hide();
                $('.ForgotPasswordUserValidation').hide();
                $('.ForgotPasswordStep1').hide();
                $('.ForgotPasswordStep2').show();
                $('.ForgotPasswordStep3').show();
                $('.ForgotPasswordStep4').show();
                if (gPasswordUsePasswordPolicy) {
                    $('.ForgotPasswordScore').show();
                }
                $('#uForgotPasswordSecurityQuestion').text(aData.SecurityQuestion);
                $('#uForgotPasswordNewPassword').val("");
                $('#uForgotPasswordUserError').hide();
                $('#uForgotPasswordQuestionError').hide();
                hideScoreCard();
            } else {
                $('#uForgotPasswordUserError').show();
            }

            if (aData.SecurityQuestion === '-1' || aData.SecurityQuestion === '') {
                $('.ForgotPasswordStep2').hide();
                $('.ForgotPasswordStep3').hide();
            }
        //}
    }
}

function getPasswordResetDetails_OnFailure(aParams, a, b, c) {
    var l = '';
}

function getUserIdData() {
    "use strict";
   var lUserName = $('#uForgotPasswordUserName').val();
   callAjax('GetPasswordResetDetails', { 'aUserName': lUserName }, getPasswordResetDetails_OnComplete, getPasswordResetDetails_OnFailure, null);
   
}

$(document).ready(function () {
    var iec = new IECompatibility();

    if (iec.IsOn !== undefined) {
        if (iec.IsOn && iec.IsIE) {
            var lButtonBar = GenerateButtonCommandBar(),
                lHtml = [];
            lHtml.push('<p>Please turn compatibility mode off for best user experience. </p>');
            lHtml.push('<p>This can be done by de-selecting the Compatibility View button on the Internet Explorer address bar (see below).</p>');
            lHtml.push('<div style="text-align:center; width:300px; margin-left:auto; margin-right:auto;">');
            lHtml.push('<div class="CompatibilityModeImage"></div>');
            lHtml.push('<p>When the CompatibilityView button is selected this indicates that compatibility mode is enabled.</p>');
            lHtml.push('</div>');
            lHtml.push('<p>For additional information on compatibility mode <a target="_blank" href="http://windows.microsoft.com/en-us/internet-explorer/products/ie-9/features/compatibility-view"> (click here) </a>. </p>');
            GenerateButton('Close', 'Close', 'ClosePopup();').appendTo(lButtonBar);
            DisplayPopup('Compatability Mode', lHtml.join(''), lButtonBar, true);
        }
    }
});

function IECompatibility() {
    var agentStr = navigator.userAgent;
    this.IsIE = false;
    this.IsOn = undefined;  //defined only if IE
    this.Version = undefined;

    if (agentStr.indexOf("MSIE 7.0") > -1) {
        this.IsIE = true;
        this.IsOn = true;
        if (agentStr.indexOf("Trident/6.0") > -1) {
            this.Version = 'IE10';
        } else if (agentStr.indexOf("Trident/5.0") > -1) {
            this.Version = 'IE9';
        } else if (agentStr.indexOf("Trident/4.0") > -1) {
            this.Version = 'IE8';
        } else {
            this.IsOn = false; // compatability mimics 7, thus not on
            this.Version = 'IE7';
        }
    } //IE 7
}
function getServerStatus_OnSuccess(aParam, aData) {
    "use strict";
    var lFailedCount = aData.ObjectsFailed.length,
        lSuccessCount = aData.ObjectsLoaded - (lFailedCount),
        lLoadingStatus = (lSuccessCount / aData.ObjectsRequested) * 100,
        lLoadingHtml = [];
    if (aData.IsInitialized && lFailedCount === 0) {
        $('.Initializing').hide();
        if (window.location.href.indexOf('authenticationKey') !== -1) {
            $('#uPopupPanel').show();
            veritracks.security.sso();
        } else {
            $('.Login').show();
            $('#uUserName').focus();
        }

    } else {
        lLoadingHtml.push(lSuccessCount.toString());
        lLoadingHtml.push(' out of ');
        lLoadingHtml.push(aData.ObjectsRequested.toString());
        if (lFailedCount > 0) {
            lLoadingHtml.push(' (');
            lLoadingHtml.push(lFailedCount.toString());
            lLoadingHtml.push(' errors)');
        }
        $('#uStatusOutput').text(lLoadingHtml.join(''));
        window.setTimeout(doLoad, 500);
    }
    if (lLoadingStatus === 100) {
        if (!lIsSiteUp) {
            lIsSiteUp = true;
        }
    }
    $("#uLoadingContainer").width(lLoadingStatus + '%');   
}
function getServerStatus_OnFailure(aParams, a, b, c) {
    "use strict";
    //alert('failure');
    $('#uStatusOutput').text(b + ': ' + c + ' (' + (mFailureCount + 1) + ')');
    mFailureCount++;
    if (mFailureCount < 5) {
        window.setTimeout(doLoad, 1000);
    } else {
        mFailureCount = 0;
        window.setTimeout(doLoad, 10000);
    }
}

function doLoad() {
    "use strict";
    callAjax('GetStatus', null, getServerStatus_OnSuccess, getServerStatus_OnFailure, 0, false);
}

function ObjectLength(aObject) {
    "use strict";
    var lKey,
        length = 0;

    for (lKey in aObject) {
        if (aObject.hasOwnProperty(lKey)) {
            length++;
        }
    }

    return length;
}

function DisplayPopup(aTitle, aContentHtml, aButtonBarHtml, aModal) {
    "use strict";
    if (isNullOrUndefined(aModal)) {
        aModal = false;
    }
    var lCloseButtonClass = '',
        lCloseButtonAction = '';
    if (!aModal) {
        lCloseButtonClass = 'PopupClose Clickable';
        lCloseButtonAction = 'ClosePopup()';
    }
    var lTable = $('<table/>', {
        'class': 'PopupWindow',
        'cellspacing': '0px',
        'cellpadding': '0px'
    }),
    lTableRow1 = $('<tr/>', {
        'class': 'PopupTitle'
    }),
    lTableRow1Cell1 = $('<td/>', {
        'class': 'PopupTitle',
        'text': aTitle
    }),
    lTableRow1Cell2 = $('<td/>', {
        'class': lCloseButtonClass,
        'onclick': lCloseButtonAction
    }),
    lTableRow2 = $('<tr/>', {
        'class': 'PopupContent'
    }),
    lTableRow2Cell1 = $('<td/>', {
        'id': 'uPopupContent',
        'class': 'PopupContent',
        'colspan': '2'
    }),
    lTableRow3 = $('<tr/>', {
        'class': 'ButtonBar'
    }),
    lTableRow3Cell1 = $('<td/>', {
        'class': 'ButtonBar',
        'colspan': '2'
    }),
    lPopupPanel = $('#uPopupPanel'),
    lPopupContainer = document.getElementById('uPopupContainer');

    lPopupContainer.innerHTML = '';
    if (aModal) {
        lPopupPanel.click(function () { });
    } else {
        lPopupPanel.click(function (aEvent) {
            if (aEvent.srcElement.id === 'uPopupContainer') {
                ClosePopup();
            }
        });
    }

    lTableRow1Cell1.appendTo(lTableRow1);
    lTableRow1Cell2.appendTo(lTableRow1);
    lTableRow1.appendTo(lTable);
    $(aContentHtml).appendTo(lTableRow2Cell1);
    lTableRow2Cell1.appendTo(lTableRow2);
    lTableRow2.appendTo(lTable);
    $(aButtonBarHtml).appendTo(lTableRow3Cell1);
    if (aButtonBarHtml !== null) {
        $(lTableRow3Cell1).appendTo(lTableRow3);
        $(lTableRow3).appendTo(lTable);
    }
    lTable.appendTo(lPopupContainer);

    $(lPopupPanel).show();

}

function ClosePopup() {
    "use strict";
    var lPopupPanel = document.getElementById('uPopupPanel');
    $(lPopupPanel).hide();
}

function GenerateButtonCommandBar() {
    "use strict";
    return $('<div class="ButtonCommandBar"></div>');
}

function privateGenerateButton(aText, aCompleteClass, aOnClick) {
    "use strict";
    var lButton,
        lHtml = [];
    lHtml.push('<div ');
    if (!isNullOrUndefined(aOnClick)) {
        if (typeof aOnClick === 'string') {
            lHtml.push('onclick="');
            lHtml.push(aOnClick);
            lHtml.push('" ');
        }
    }
    lHtml.push('class="');
    lHtml.push(aCompleteClass);
    lHtml.push('">');
    lHtml.push(aText);
    lHtml.push('</div>');
    lButton = $(lHtml.join(''));
    if (typeof aOnClick === 'function') {
        lButton.click(aOnClick);
    }
    return lButton;
}

function GenerateButton(aText, aClass, aOnClick) {
    "use strict";
    var lClass = 'Clickable Button';
    if (!isNullOrUndefined(aClass) && aClass !== '') {
        lClass += ' ' + aClass + 'Button LargeIconButton';
    }
    return privateGenerateButton(aText, lClass, aOnClick);
    //lHtml.push('<div ');
    //if (!isNullOrUndefined(aOnClick)) {
    //    if (typeof aOnClick === 'string') {
    //        lHtml.push('onclick="');
    //        lHtml.push(aOnClick);
    //        lHtml.push('" ');
    //    }
    //}
    //lHtml.push('class="');
    //lHtml.push(lClass);
    //lHtml.push('">');
    //lHtml.push(aText);
    //lHtml.push('</div>');
    //lButton = $(lHtml.join(''));
    //if (typeof aOnClick === 'function') {
    //    lButton.click(aOnClick);
    //}
}

//function GenerateIconButton(aText, aClass, aOnClick) {
//    "use strict";
//    var lClass = 'Clickable IconButton';
//    if (!isNullOrUndefined(aClass) && aClass !== '') {
//        lClass += ' ' + aClass + 'Button';
//    }
//    return privateGenerateButton(aText, lClass, aOnClick);
//    //"use strict";
//    //var lClass = 'Clickable IconButton';
//    //if (typeof aClass !== 'undefined' && aClass !== null && aClass !== '') {
//    //    lClass += ' ' + aClass + 'Button';
//    //}
//    //var lButton = $('<div/>', {
//    //    'class': lClass,
//    //    'text': aText,
//    //    'onclick': aOnClick
//    //});
//    //return lButton;
//}

//function GenerateSmallButton(aText, aClass, aOnClick) {
//    "use strict";
//    var lClass = 'Clickable SmallButton';
//    if (!isNullOrUndefined(aClass) && aClass !== '') {
//        lClass += ' ' + aClass + 'Button';
//    }
//    return privateGenerateButton(aText, lClass, aOnClick);
//    //var lClass = 'Clickable SmallButton';
//    //if (typeof aClass !== 'undefined' && aClass !== null && aClass !== '') {
//    //    lClass += ' ' + aClass + 'Button';
//    //}
//    //var lButton = $('<div/>', {
//    //    'class': lClass,
//    //    'text': aText,
//    //    'onclick': aOnClick
//    //});
//    //return lButton;
//}

function ORIsRetrived_Success(aParams, aData) {
    var d = aData;
}

function uSearchOrganizations() {
    "use strict";
    var search = $("#uOrganizationsText").val();   

    if (search == '') {
        uClearOrganizations(true);
        return;
    }

    //search global,ignore case
    var valueRegX;
    try {
        valueRegX = new RegExp(search, "gi");  
    }
    catch (exception) {
        //invalid expression
        uClearOrganizations(true);
        return;
    }
    var foundCount = 0;
    var browser = window.navigator.userAgent;
    var matchedIndex = 0;

    //remove any previous searches
    uClearOrganizations(false);
   
    $("li[class|= 'OriLiCommon']").each(function (index) {
        var matchIndex;       
        var labelText = $("label[for|='uOrganizationSelect" + this.getAttribute("id") + "']").text();
       
        matchIndex = labelText.search(valueRegX);        
        //replace text with '<span class="Q">'
        if (matchIndex != -1) {
            var labelTextMatches = labelText.match(valueRegX);            
            var newLabelText = "";
            var j = 0;
            while (j < labelText.length) {
                var matchedText = "";
                for (var i = 0; i < labelTextMatches.length; i++) {                    
                        if (labelText.substr(j, labelTextMatches[i].length) == labelTextMatches[i]) {
                            matchedText = '<span class="Q">' + labelTextMatches[i] + '</span>';
                            j = j + labelTextMatches[i].length;
                            break;
                        }
                }

                if (matchedText != "") {
                    newLabelText = newLabelText + matchedText;                    
                } else {
                    newLabelText = newLabelText + labelText[j];
                    j++;
                }
                
                matchedText = "";
            }
            matchedIndex = index;
            $("label[for|='uOrganizationSelect" + this.getAttribute("id") + "']").html(newLabelText);            
            foundCount++;
            if ($("#link" + this.getAttribute("id")).hasClass("plusSignImage")) {
                $("#link" + this.getAttribute("id")).click();
            }
        } else {
            if ($("#link" + this.getAttribute("id")).hasClass("plusSignImage")) {
                $("#link" + this.getAttribute("id")).click();
            }
        }//end of if
                
    });
    
    if (foundCount > 0) {
        var matchId = $("li[class|= 'OriLiCommon']:eq(" + matchedIndex + ")")[0].id;
        $("#uOrganizationSelect" + matchId).focus();
    }    
    $("#uOrganizationsText").focus();
   
}

function uClearOrganizations(clearFlag) {
    "use strict";
    if (clearFlag) {
        $("#uOrganizationsText").val('');        
    } 
    var browser = window.navigator.userAgent;
    //remove any previous searches
    $("span[class|= 'Q']").each(function (index) {        
        var currentSpanHtml = this.innerHTML;        
        if (typeof this.parentNode != 'undefined' && this.parentNode != null) {

            if (browser.indexOf('MSIE') != -1) {
                $(this.parentElement).html(this.parentNode.innerText);
            } else {
                $(this.parentElement).html(this.parentNode.textContent);
            }
                              
        }
        
    });

    
}

function uClickSearchBoxInit() {
    $("#uOrganizationsText").val('');
}

function uFocusSearchBoxInit() {
    if ($("#uOrganizationsText").val() == 'find organization') {
        $("#uOrganizationsText").val('');
    } 
}

function uFocusOutInit() {
    if ($("#uOrganizationsText").val() == '') {
        $("#uOrganizationsText").val('find organization');
    }
}

function prepareObjectForWcf(aObject) {
    var lNewObject = $.extend({}, aObject),
        lProperty,
        lValue,
        lMatch = /date/i;

    lMatch.compile(lMatch);
    for (lProperty in aObject) {
        if (aObject.hasOwnProperty(lProperty)) {
            lValue = aObject[lProperty];
            if (typeof lValue === 'object' && (!isNullOrUndefined(lValue)) && (!isNullOrUndefined(lValue.constructor.toString().match(lMatch)))) {
                lNewObject[lProperty] = lValue.toWcf();
            }
        }
    }
    return lNewObject;
}

function WriteSingle(aObject, aOnSuccess, aOnFailure, aOutParams, aIsPersist) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
        lIsPersist = true;
    if (!isNullOrUndefined(aIsPersist)) {
        lIsPersist = aIsPersist;
    }
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteSingle', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aObject': { 'Data': prepareObjectForWcf(aObject) },
            'aPersist': lIsPersist,
            'aAsync': false
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}


if (!Array.prototype.indexOf) { Array.prototype.indexOf = function (elt /*, from*/) { var len = this.length >>> 0; var from = Number(arguments[1]) || 0; from = (from < 0) ? Math.ceil(from) : Math.floor(from); if (from < 0) from += len; for (; from < len; from++) { if (from in this && this[from] === elt) return from; } return -1; }; }
if (typeof String.prototype.trim !== 'function') { String.prototype.trim = function () { return this.replace(/^\s+|\s+$/g,''); } }

function get_browser() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE';
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) { return 'Opera ' + tem[1]; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return M[0];
}

function get_browser_version() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return tem[1] || '';
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) { return 'Opera ' + tem[1]; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return M[1];
}













//2FA SETUP
$(document).on("keypress", '#2falogincode', function (evt) {
    if (evt.keyCode < 48 || evt.keyCode > 57) {
        evt.preventDefault();
    } else {
        if ($('#2falogincode').val().length >= 6) {
            evt.preventDefault();
        }
    }
});

function initiate2FA(aParams, aData) {
    if (aData) {
        $('#uLoginPanel').hide();
        $('#u2FAPanel').show();
    } else {
        getUserDetails();
    }
}

function Is2FARequired(aOutParams) {
    var lToken = veritracks.security.controller.tryGetSecurityToken();

    callAjax('Is2FARequired', {
        'aSecurityToken': lToken,
        'aSecurityContextId': -1
    }, initiate2FA, null, aOutParams);
}

function begin2FactorAuthentication() {
    var lToken = veritracks.security.controller.tryGetSecurityToken();
    var code = $('#2falogincode').val();

    callAjax('Verify2faTotp', {
        'aSecurityToken': lToken,
        'aSecurityContextId': -1,
        'aCode': code
    }, begin2FactorAuthentication_OnSuccess, null, null);
}

function begin2FactorBackupAuthentication() {
    var lToken = veritracks.security.controller.tryGetSecurityToken();
    var code = $('#2falogincode').val();

    callAjax('Verify2faHotp', {
        'aSecurityToken': lToken,
        'aSecurityContextId': -1,
        'aCode': code
    }, begin2FactorAuthentication_OnSuccess, null, null);
}

function begin2FactorAuthentication_OnSuccess(aParams, aData) {
    if(aData == "FAILED") {
        $('#u2FAError').show();
    } else if (aData == "LOCKED") {
        $('#u2FALockedError').show();
    } else {
        $('#u2FAError').hide();
        getUserDetails();
    }
}

function u2FAHelp_OnClick() {
    var lHtml = [];
    var lButtonBar = GenerateButtonCommandBar();
    lHtml.push('<div> <strong>For assistance with retrieving a 6-digit backup code or to re-setup your Two-Factor Authentication, please contact your administrator. </strong></div>');
    lHtml.push('<br><div><strong>If you already have your backup codes, you can attempt to enter by clicking below.</strong></div>')

    GenerateButton('Enter backup codes', 'Continue', function () {
        ClosePopup();
        $('.2FATotp').fadeOut(100, function () {
            $('.2FAHotp').fadeIn()
        })
    }).appendTo(lButtonBar);

    GenerateButton('Enter 2fa code', 'Continue', function () {
        ClosePopup();
        $('.2FAHotp').fadeOut(100, function () {
            $('.2FATotp').fadeIn()
        })
    }).appendTo(lButtonBar);
    DisplayPopup("Two-Factor Authentication Help", lHtml.join(''), lButtonBar, false);
}




function gup(name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return results == null ? null : results[1];
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        }
    });
}


if (!Array.prototype.filter) {
    Array.prototype.filter = function (fun/*, thisArg*/) {
        'use strict';

        if (this === void 0 || this === null) {
            throw new TypeError();
        }

        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== 'function') {
            throw new TypeError();
        }

        var res = [];
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for (var i = 0; i < len; i++) {
            if (i in t) {
                var val = t[i];

                // NOTE: Technically this should Object.defineProperty at
                //       the next index, as push can be affected by
                //       properties on Object.prototype and Array.prototype.
                //       But that method's new, and collisions should be
                //       rare, so use the more-compatible alternative.
                if (fun.call(thisArg, val, i, t)) {
                    res.push(val);
                }
            }
        }

        return res;
    };
}

if (typeof URLSearchParams == 'undefined'){
    (function (w) {
        w.URLSearchParams = w.URLSearchParams || function (searchString) {
            var self = this;
            self.searchString = searchString;
            self.get = function (name) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
                if (results == null) {
                    return null;
                }
                else {
                    return decodeURI(results[1]) || 0;
                }
            };
        }
    })(window);
}